import { cn as e } from "../../shared/utils.js";
import { useTranslation as t } from "../../i18n/hooks.js";
import { Skeleton as n } from "../../skeleton/skeleton.js";
import { TooltipTextOverflow as r } from "../../tooltip/tooltip-text-overflow.js";
import { Checkbox as i } from "../../checkbox/primitive/index.js";
import { TableSelectionActionsProvider as a, useTableSelectionActions as o } from "./selection-actions-context.js";
import { TableSelectionProvider as s, useTableSelection as c } from "./selection-context.js";
import { Fragment as l, createContext as u, forwardRef as d, isValidElement as f, useContext as p, useEffect as m, useMemo as h } from "react";
import { jsx as g, jsxs as _ } from "react/jsx-runtime";
//#region src/table/primitive/index.tsx
var v = u({}), y = ({ checked: e, indeterminate: t = !1, label: n, onChange: r }) => /* @__PURE__ */ g(i.Root, {
	"aria-label": n,
	checked: e,
	indeterminate: t,
	size: "sm",
	onCheckedChange: r,
	onClick: (e) => e.stopPropagation(),
	children: !t && /* @__PURE__ */ g(i.Indicator, { size: "sm" })
}), b = ({ children: t, className: n, onClearSelection: r, onSelectAll: i, onSelectionChange: o, onSortChange: c, selectedKeys: l, selectionMode: u, sortDescriptor: d, ...f }) => {
	let p = h(() => ({
		sortDescriptor: d,
		onSortChange: c
	}), [c, d]);
	return /* @__PURE__ */ g(a, {
		onClearSelection: r,
		onSelectAll: i,
		children: /* @__PURE__ */ g(s, {
			selectedKeys: l,
			selectionMode: u,
			onSelectionChange: o,
			children: /* @__PURE__ */ g(v.Provider, {
				value: p,
				children: /* @__PURE__ */ g("table", {
					...f,
					className: e("w-full", n),
					children: t
				})
			})
		})
	});
};
b.displayName = "Table.Root";
var x = ({ allowSelectAll: n = !0, className: r, children: i, selectedAll: a = !1, ...s }) => {
	let { t: l } = t(), { isEveryRowSelected: u, isSomeRowSelected: d, onDeselectEveryRow: f, onSelectEveryRow: p, selectionMode: m } = c(), { onClearSelection: h, onSelectAll: v } = o(), b = a || u, x = !b && d;
	return /* @__PURE__ */ g("thead", {
		...s,
		className: e("border-table-cell-border border-b", r),
		children: /* @__PURE__ */ _("tr", { children: [m !== "none" && /* @__PURE__ */ g("th", {
			className: "tablet:w-10 tablet:pl-6 w-8 py-3 pr-0 pl-4 align-middle",
			scope: "col",
			children: m === "multiple" && n && /* @__PURE__ */ g(y, {
				checked: b,
				indeterminate: x,
				label: l("public_pages_purchase.table.mobile.select_all"),
				onChange: (e) => e ? (v ?? p)() : (h ?? f)()
			})
		}), i] })
	});
};
x.displayName = "Table.Header";
var S = ({ className: t, ...n }) => /* @__PURE__ */ g("tbody", {
	...n,
	className: e("[&_tr:last-child]:border-0", t)
});
S.displayName = "Table.Body";
var C = d(({ className: n, children: r, id: i, onClick: a, onKeyDown: o, tabIndex: s, ...l }, u) => {
	let { t: d } = t(), { isSelected: f, onToggle: p, registerRow: h, selectionMode: v } = c(), b = v !== "none" && i != null, x = i != null && f(i), S = !!a;
	m(() => {
		if (!(!b || i == null)) return h(i);
	}, [
		i,
		b,
		h
	]);
	let C = (e) => {
		o?.(e), !(!S || e.defaultPrevented || e.key !== "Enter") && e.target === e.currentTarget && e.currentTarget.click();
	};
	return /* @__PURE__ */ _("tr", {
		ref: u,
		...l,
		"aria-selected": b ? x : void 0,
		className: e("border-table-cell-border hover:bg-table-cell-bg-hover focus-visible:focus-ring-primary desktop:h-15 border-b transition-colors", x && "bg-table-cell-bg-selected hover:bg-table-cell-bg-selected", S && "cursor-pointer", n),
		"data-selected": x || void 0,
		tabIndex: s ?? (S ? 0 : void 0),
		onClick: a,
		onKeyDown: C,
		children: [b && /* @__PURE__ */ g("td", {
			className: "tablet:w-10 tablet:pl-6 w-8 py-3 pr-0 pl-4 align-middle",
			children: /* @__PURE__ */ g(y, {
				checked: x,
				label: d("public_pages_purchase.table.mobile.select_row"),
				onChange: () => p(i)
			})
		}), r]
	});
});
C.displayName = "Table.Row";
var w = ({ sortDirection: t }) => {
	let n = t === "ascending", r = t === "descending";
	return /* @__PURE__ */ _("svg", {
		width: "16",
		height: "16",
		viewBox: "0 0 16 16",
		xmlns: "http://www.w3.org/2000/svg",
		className: e("shrink-0 transition-colors", n || r ? "text-icon-primary" : "text-icon-tertiary group-hover:text-icon-secondary"),
		"aria-hidden": "true",
		children: [/* @__PURE__ */ g("path", {
			d: "M5 13V3M5 3L2 6M5 3L8 6",
			stroke: "currentColor",
			strokeWidth: "1.5",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			className: e("transition-opacity duration-200", r && "opacity-30")
		}), /* @__PURE__ */ g("path", {
			d: "M11 3V13M11 13L8 10M11 13L14 10",
			stroke: "currentColor",
			strokeWidth: "1.5",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			className: e("transition-opacity duration-200", n && "opacity-30")
		})]
	});
}, T = ({ allowsSorting: n, children: i, className: a, id: o, sortDirection: s, ...c }) => {
	let { t: l } = t(), { onSortChange: u, sortDescriptor: d } = p(v), f = o != null && d?.column === o, m = s ?? (f ? d?.direction : void 0), h = /* @__PURE__ */ _("div", {
		className: "flex items-center gap-2.5",
		children: [typeof i == "string" ? /* @__PURE__ */ g(r, { children: i }) : /* @__PURE__ */ g("span", {
			className: "min-w-0 truncate",
			children: i
		}), n && /* @__PURE__ */ g("span", {
			className: "group flex size-5 items-center justify-center",
			children: /* @__PURE__ */ g(w, { sortDirection: m })
		})]
	});
	return /* @__PURE__ */ g("th", {
		...c,
		"aria-sort": n ? m ?? "none" : void 0,
		className: e("text-table-header-text py-3 text-left align-middle text-sm font-medium uppercase transition-colors", a, "tablet:first:pl-6 tablet:last:pr-6 px-4"),
		scope: "col",
		children: n ? /* @__PURE__ */ _("button", {
			className: "focus-visible:focus-ring-primary flex w-full cursor-pointer items-center text-left uppercase",
			type: "button",
			onClick: () => {
				o != null && u?.({
					column: o,
					direction: m === "ascending" ? "descending" : "ascending"
				});
			},
			children: [h, /* @__PURE__ */ g("span", {
				className: "sr-only",
				children: l("public_pages_purchase.table.sort")
			})]
		}) : h
	});
};
T.displayName = "Table.Head";
function E(e) {
	return e == null || typeof e == "boolean" || typeof e == "string" || typeof e == "number" ? !0 : Array.isArray(e) ? e.every(E) : f(e) && e.type === l ? E(e.props.children) : !1;
}
var D = ({ children: t, className: n, truncate: i, ...a }) => {
	let o = i ?? E(t);
	return /* @__PURE__ */ g("td", {
		...a,
		className: e("text-text-secondary py-3 align-middle text-base font-normal", n, "tablet:first:pl-6 tablet:last:pr-6 px-4"),
		children: o ? /* @__PURE__ */ g("div", {
			className: "flex items-center",
			children: /* @__PURE__ */ g(r, { children: t })
		}) : t
	});
};
D.displayName = "Table.Cell";
var O = ({ children: t, className: r, ...i }) => /* @__PURE__ */ g(D, {
	...i,
	className: e("max-desktop:py-6", r),
	children: t ?? /* @__PURE__ */ g(n, { className: "h-3.5 w-full" })
});
O.displayName = "Table.LoaderCell";
var k;
(function(e) {
	e.Root = b, e.Header = x, e.Body = S, e.Row = C, e.Head = T, e.Cell = D, e.LoaderCell = O;
})(k ||= {});
//#endregion
export { k as Table };
